module.exports = __webpack_public_path__ + "static/media/LiveStream.224e8283.svg";